module.exports = __webpack_public_path__ + "static/media/home_page_banner@768.236d8d3e.png";